import React, { Fragment } from 'react';

const SubGroup = props => { 
    let label = null;
    let labelClasses = ['control-label'];
    let fieldClasses = [''];

    const anotherProperty = props.anotherProperty;

    const star = (
        <span style={{ color: "red" }}>❋</span>
    );

    if(props.labelWidth && props.labelWidth > 0){
        labelClasses.push('col-sm-' + props.labelWidth)
        label = (
            <label className={labelClasses.join(' ')}>
                {props.showStar && star}
                {props.label}
            </label>
        );
    }

    if(props.fieldWidth) {
        fieldClasses.push('col-sm-' + props.fieldWidth + ' ' + anotherProperty);
    }

    return (
        <Fragment>
            {label}
            <div className={fieldClasses.join(' ')} style={props.style}>
                {props.children}
            </div>
        </Fragment>
    );
}

export default SubGroup;